import { Outlet } from "react-router-dom";
import Header from "../Header/Header"; // ⚠️ verify it's the correct path
import Footer from "../Footer/Footer";

const Layout = () => {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;